import { FC, useMemo } from 'react';
import { observer } from "mobx-react-lite";
import DeleteElementBlue from "../../../assets/deleteElementGray.svg";
import DeleteElementGray from "../../../assets/grayDelete.svg";

export interface IDeleteButtonProps {
    onClickFunc: () => void;
    permission: boolean;
}

const BtnDelete: FC<IDeleteButtonProps> = ({ onClickFunc, permission }) => {
    const buttonIcon = useMemo(() => 
        permission ? DeleteElementBlue : DeleteElementGray, 
        [permission]
    );

    return (
        <div className="button-base btn_margin-left" onClick={onClickFunc}>
            <img 
                src={buttonIcon} 
                alt="Delete" 
                title={permission ? "Удалить" : "Нет прав для удаления"}
            />
        </div>
    );
};

export default observer(BtnDelete);